import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/site";
import { Reveal, SectionLabel } from "./Reveal";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <SectionLabel index="04">Customer Reviews</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Trusted by Homes<br /><span className="text-neutral-500">& Businesses</span></h2>
      </Reveal>
      <div className="mt-16 grid gap-6 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 100} className={i === 1 ? "lg:translate-y-10" : ""}>
            <figure data-testid={`testimonial-${i + 1}`} className="trust-card relative h-full border border-white/10 bg-gradient-to-b from-white/[0.04] to-transparent p-8">
              <Quote className="h-8 w-8 text-[#1E9BFF]" />
              <div className="mt-6 flex gap-1">
                {[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-[#1E9BFF] text-[#1E9BFF]" />)}
              </div>
              <blockquote className="mt-4 text-neutral-200">"{t.quote}"</blockquote>
              <figcaption className="mt-8 border-t border-white/10 pt-5">
                <div className="font-display text-lg font-bold uppercase">{t.name}</div>
                <div className="font-mono text-xs uppercase tracking-widest text-neutral-500">{t.role}</div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
